import { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * "X personnes ont acheté ce produit" small badge.
 * - Real count from backend (min 7 with deterministic per-product seed 7..15).
 * - Increments naturally as real paid orders come in.
 */
export default function PurchaseCount({ slug }) {
  const [count, setCount] = useState(null);
  useEffect(() => {
    if (!slug) return;
    let mounted = true;
    axios.get(`${API}/products/${slug}/purchase-count`).then((r) => {
      if (mounted) setCount(r.data?.count ?? null);
    }).catch(() => {});
    return () => { mounted = false; };
  }, [slug]);

  if (count == null || count <= 0) return null;
  return (
    <p className="inline-flex items-center gap-1.5 text-xs text-sage-dark" data-testid="purchase-count">
      <Users size={14} />
      <span><strong>{count}</strong> {count > 1 ? "personnes ont acheté" : "personne a acheté"} ce produit</span>
    </p>
  );
}
